const Constants = Object.freeze({
    GAS_PRICE: "0.0000002",
    BLOCK_EXPLORER: 'https://explorer.demo.technogold.com',
    DEFAULT_CURRENCY: 'ucrg',
    DEFAULT_DISPLAY_CURRENCY: 'crg'
})

export default Constants
